import { createTrackingUtils } from "../index.js";
import useProfiler from "../../../hooks/useProfiler.js";
import { useEffect } from "react";
const utils = createTrackingUtils({
    name: "flights_funnel_chip_sorting_desktop",
    defaultStage: 1,
    stages: {
        main: 1,
        direct: 2,
        meta: 3
    },
    goals: {}
});
export const useTrackChipSortingDesktop = () => {
    const { isDesktop, isMobile, isMeta, isDirect, isLongHaul, isWeekendStay, isFamily } = useProfiler();
    useEffect(() => {
        isDirect() && utils.stages.direct();
        isMeta() && utils.stages.meta();
    }, [isDesktop, isDirect, isFamily, isLongHaul, isMeta, isMobile, isWeekendStay]);
};
export default utils;
